import { render } from "./SC_adj.vue?vue&type=template&id=49b9a586"
import script from "./SC_adj.vue?vue&type=script&lang=js"
export * from "./SC_adj.vue?vue&type=script&lang=js"

import "./SC_adj.vue?vue&type=style&index=0&id=49b9a586&lang=css"

import exportComponent from "C:\\Users\\sisco\\Documents\\Compras\\SC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__